import {
  afterNextRender,
  Component,
  computed,
  DestroyRef,
  ElementRef,
  inject,
  input,
  InputSignal,
  signal,
  Signal,
} from '@angular/core';
import { ChronoPipe } from '../../pipes/chrono.pipe';

@Component({
  selector: 'app-timebar',
  imports: [],
  template: ` <div class="timebar">
    @for (timer of timers(); track $index) {
      <div>{{ timer }}</div>
    }
  </div>`,
  styleUrl: './timebar.component.scss',
})
export class TimebarComponent {
  duration: InputSignal<number> = input.required();
  private el = inject(ElementRef);
  private destroyRef = inject(DestroyRef);
  width = signal(0);

  chronoPipe: ChronoPipe = new ChronoPipe();

  constructor() {
    afterNextRender(() => {
      const observer = new ResizeObserver((entries) => {
        this.width.set(entries[0].contentRect.width);
      });
      observer.observe(this.el.nativeElement);
      this.destroyRef.onDestroy(() => observer.disconnect());
    });
  }

  timerCount: Signal<number> = computed(() => Math.floor(this.width() / 80));

  timers: Signal<string[]> = computed(() => {
    const count = this.timerCount();
    const duration = this.duration();
    if (count <= 0) return [];
    return Array.from({ length: count }, (_, i) => {
      const seconds = Math.round((i * duration) / (count - 1 || 1));
      return this.chronoPipe.transform(seconds);
    });
  });
}
